import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Custom scrollbar styles */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1d3f0;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a8c1e9;
  }

  /* For Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: #c1d3f0 transparent;
  }

  /* For textarea in editor */
  textarea {
    scrollbar-width: thin;
    scrollbar-color: #c1d3f0 transparent;
  }
`;

export default GlobalStyles; 